import React, { useState, useEffect }  from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AppLayout from "./app-layout";
import BudgetHome from './budget-home/budget-home';
import BudgetTool from './budget-tool/budget-tool';
import Experiences from './experiences/experiences';
import ExperiencesEdit from './experiences/experience-form/experiences-edit';
import Flights from "./flights/flights";
import FlightsEdit from "./flights/flights-edit";
import FlightsExperimental from "./flights-experimental/flights-experimental";
import FlightsExperimentalEdit from "./flights-experimental/flights-experimental-edit";
import Settings from "./settings/settings";
import Assistant from "./assistant/assistant";
import Passport from "./passport/passport";
import PassportEdit from "./passport/passport-edit";
import BudgetCalculator from "./budget-calculator/budget-calculator";
import Agenda from "./agenda/agenda";
import Status from "./status/status";
import RebelExperiences from './rebel-experiences/rebel-experiences';
import RebelExperiencesEdit from './rebel-experiences/experience-form/rebel-experiences-edit';
import RebelSettings from "./rebel-settings/rebel-settings";
import RebelSettingsEdit from "./rebel-settings/rebel-settings-edit";
import AgendaConfig from "./agenda-config/agenda-config";
import AgendaConfigEdit from "./agenda-config/agenda-config-edit";
import RebelBudget from "./rebel-budget/rebel-budget";
import RebelBudgetClients from "./rebel-budget/rebel-budget-clients";

const BudgetApp = (props) => {

    console.log("BudgetApp props", props);

    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [collapsed, setCollapsed] = useState(false);

    let client = false;
    if (window.location.href.indexOf("/budget-app/experiences/") > -1) {
        client = true;
        if (window.location.href.indexOf("edit") > -1) {
            client = false;
        }
    }
    if (window.location.href.indexOf("/budget-app/flights/") > -1) {
        client = true;
        if (window.location.href.indexOf("edit") > -1) {
            client = false;
        }
    }
    if (window.location.href.indexOf("/budget-app/flights-experimental/") > -1) {
        client = true;
        if (window.location.href.indexOf("edit") > -1) {
            client = false;
        }
    }
    if (window.location.href.indexOf("/budget-app/passport/") > -1) {
        client = true;
        if (window.location.href.indexOf("edit") > -1) {
            client = false;
        }
    }
    if (window.location.href.indexOf("/budget-app/rebel-experiences/") > -1) {
        client = true;
        if (window.location.href.indexOf("edit") > -1) {
            client = false;
        }
    }
    if (window.location.href.indexOf("/budget-app/rebel-budget") > -1) {
        client = true;
    }

    // Detect if we're on a REBEL page (experiences or settings)
    let isRebelPage = false;
    if (window.location.href.indexOf("/budget-app/rebel-experiences") > -1 ||
        window.location.href.indexOf("/budget-app/rebel-settings") > -1 ||
        window.location.href.indexOf("/budget-app/agenda-config") > -1 ||
        window.location.href.indexOf("/budget-app/rebel-budget") > -1 ||
        window.location.href.indexOf("/budget-app/rebel-clients") > -1) {
        isRebelPage = true;
    }
  
    useEffect(() => {
        function handleWindowResize() {
          setWindowSize(getWindowSize());
        }
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
  
    function getWindowSize() {
        const {innerWidth, innerHeight} = window;
        return {innerWidth, innerHeight};
    }


    return (
      <Router>
        <AppLayout
            windowSize={windowSize}
            collapsed={collapsed}
            setCollapsed={(x) => setCollapsed(x)}
            client={client}
            isRebelPage={isRebelPage}
        >
            <Switch>
                <Route title="Budget" path="/budget-app/budget-demo">
                    <BudgetTool collapsed={collapsed}/>
                </Route>
                <Route title="Experiences" path="/budget-app/experiences/edit/:experience">
                    <ExperiencesEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Experiences" path="/budget-app/experiences/:experience">
                    <ExperiencesEdit collapsed={collapsed} client={true} setCollapsed={x => setCollapsed(x)} />
                </Route>
                <Route title="Experiences" path="/budget-app/experiences/">
                    <Experiences collapsed={collapsed} client={client}/>
                </Route>
                <Route title="Flights" path="/budget-app/flights/edit/:experience">
                    <FlightsEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Flights" path="/budget-app/flights/:experience">
                    <FlightsEdit collapsed={collapsed} client={true}/>
                </Route>
                <Route title="Flights" path="/budget-app/flights">
                    <Flights collapsed={collapsed}/>
                </Route>
                <Route title="Flights (exp.)" path="/budget-app/flights-experimental/edit/:experience">
                    <FlightsExperimentalEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Flights (exp.)" path="/budget-app/flights-experimental/:experience">
                    <FlightsExperimentalEdit collapsed={collapsed} client={true}/>
                </Route>
                <Route title="Flights (exp.)" path="/budget-app/flights-experimental">
                    <FlightsExperimental collapsed={collapsed}/>
                </Route>
                <Route title="Assistant" path="/budget-app/assistant">
                    <Assistant collapsed={collapsed}/>
                </Route>
                <Route title="Settings" path="/budget-app/settings">
                    <Settings collapsed={collapsed}/>
                </Route>
                <Route title="Passports" path="/budget-app/passport/edit/:experience">
                    <PassportEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Passports" path="/budget-app/passport/:experience">
                    <PassportEdit collapsed={collapsed} client={true}/>
                </Route>
                <Route title="Passports" path="/budget-app/passport">
                    <Passport collapsed={collapsed}/>
                </Route>
                <Route title="Budget Calculator" path="/budget-app/budget-calculator">
                    <BudgetCalculator collapsed={collapsed} client={client}/>
                </Route>
                <Route title="Agenda (WIP)" path="/budget-app/agenda">
                    <Agenda collapsed={collapsed} client={client}/>
                </Route>
                <Route title="Rebel Leads" path="/budget-app/rebel-clients">
                    <RebelBudgetClients collapsed={collapsed}/>
                </Route>
                <Route title="Rebel Budget" path="/budget-app/rebel-budget/view/:id">
                    <RebelBudget collapsed={collapsed} viewOnly={true}/>
                </Route>
                <Route title="Rebel Budget" path="/budget-app/rebel-budget/:id">
                    <RebelBudget collapsed={collapsed}/>
                </Route>
                <Route title="Rebel Budget" path="/budget-app/rebel-budget">
                    <RebelBudget collapsed={collapsed}/>
                </Route>
                <Route title="Rebel Experiences" path="/budget-app/rebel-experiences/edit/:experience">
                    <RebelExperiencesEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Rebel Experiences" path="/budget-app/rebel-experiences/:experience">
                    <RebelExperiencesEdit collapsed={collapsed} client={true} setCollapsed={x => setCollapsed(x)} />
                </Route>
                <Route title="Rebel Experiences" path="/budget-app/rebel-experiences/">
                    <RebelExperiences collapsed={collapsed} client={client}/>
                </Route>
                <Route title="Rebel Settings" path="/budget-app/rebel-settings/edit/:experience">
                    <RebelSettingsEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Rebel Settings" path="/budget-app/rebel-settings">
                    <RebelSettings collapsed={collapsed}/>
                </Route>
                <Route title="Agenda Config" path="/budget-app/agenda-config/edit/:id">
                    <AgendaConfigEdit collapsed={collapsed} client={false}/>
                </Route>
                <Route title="Agenda Config" path="/budget-app/agenda-config">
                    <AgendaConfig collapsed={collapsed}/>
                </Route>
                <Route title="Status" path="/budget-app/status">
                    <Status collapsed={collapsed} client={client}/>
                </Route>
                <Route title="Home" path="/budget-app/">
                    <BudgetHome collapsed={collapsed} client={client}/>
                </Route>
            </Switch>
        </AppLayout>
      </Router>
    );

}

export default BudgetApp;